import { KatapultElement, html } from '../../mixins/katapult-element.js';

import { CamelCase } from '../../modules/CamelCase.js';

class MaterialIconPicker extends KatapultElement {
  static get template() {
    return html`
      <style>
        :host {
          display: flex;
          flex-direction: column;
          overflow: hidden;
        }
        #icons {
          display: flex;
          flex-wrap: wrap;
          overflow-y: auto;
          padding: 16px;
          justify-content: center;
        }
        .iconWrapper {
          transition:
            border 0.1s,
            background 0.1s,
            font-size 0.1s;
        }
        .iconWrapper:hover {
          cursor: pointer;
          color: var(--secondary-color);
          background: var(--paper-grey-50);
          border: 1px solid var(--border);
        }
        .iconWrapper:hover material-icon {
          font-size: 48px;
        }
        .iconWrapper {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 16px;
          width: 64px;
          border-radius: 16px;
        }
        .label {
          font-size: 10pt;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-top: 4px;
        }
        paper-table {
          margin: 16px;
        }
      </style>
      <paper-table>
        <paper-row input>
          <paper-cell icon>
            <material-icon icon="search"></material-icon>
          </paper-cell>
          <paper-cell>
            <paper-input label="Search Icons" value="{{filterString}}" on-change="stopPropagation" no-label-float underline></paper-input>
          </paper-cell>
        </paper-row>
      </paper-table>
      <div id="icons">
        <template is="dom-repeat" items="[[filteredIcons]]">
          <div class="iconWrapper" flex column on-click="iconClickHandler">
            <material-icon icon="[[item]]" size="large"></material-icon>
            <div class="label">[[camelCase(item)]]</div>
          </div>
        </template>
      </div>
    `;
  }
  static get properties() {
    return {
      icons: {
        type: Array,
        value: () => []
      },
      filteredIcons: {
        type: Array,
        value: () => []
      }
    };
  }

  static get observers() {
    return ['updateFilteredIcons(icons.*, filterString)'];
  }

  constructor() {
    super();
    this.camelCase = CamelCase;
    this.stopPropagation = (e) => e.stopPropagation();
  }

  ready() {
    super.ready();
    // Load the Material Icons list.
    fetch('https://raw.githubusercontent.com/google/material-design-icons/master/font/MaterialIcons-Regular.codepoints')
      .then((res) => res.text())
      .then((text) => {
        const icons = text.split('\n').map((line) => line.split(' ')[0]);
        this.icons = icons;
      });
  }

  iconClickHandler(e) {
    this.fire('change', { value: e.model.item });
  }

  updateFilteredIcons() {
    this.filteredIcons = this.icons.filter((icon) => {
      return icon.toLowerCase().includes(this.filterString.toLowerCase());
    });
  }
}
window.customElements.define('material-icon-picker', MaterialIconPicker);
